import React from 'react'
import { connect } from 'react-redux'
import {
  Container,
  Image,
  Menu,
  Button
} from 'semantic-ui-react'

import { logout } from '../redux/actions'

const NavBar = (props) => (
<Menu fixed='top'>
      <Container>
        <Menu.Item as='a' header>
          <Image size='mini' src='/ph_app_icon.png' style={{ marginRight: '1.5em' }} />
          Plant Hospital
        </Menu.Item>
        <Menu.Item position='right'>
            <Button as='a' primary style={{ marginLeft: '0.5em' }} onClick={() => props.logout()}>
                Log Out
            </Button>
        </Menu.Item>
      </Container>
    </Menu>
)

export default connect(null, {logout})(NavBar)